module.exports = __webpack_public_path__ + "static/media/13_LauraZeiger_webfinal.c309d361.jpg";